import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default class Modal extends React.Component {

  static propTypes = {
    show: PropTypes.bool.isRequired,
    invert: PropTypes.bool,

    width: PropTypes.string,
    header: PropTypes.any,
    footer: PropTypes.any,
    onClose: PropTypes.func,
  };

  state = {
    opacity: 0,
    stateShow: true,
  };

  onClose = (e) => {
    console.log('Modal onClose')
    this.setState({
      stateShow: false,
    })
    //e.preventDefault();
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  onClickContent = (e) => {
    console.log('Modal onClickContent')
    //e.preventDefault();
    e.stopPropagation();
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    console.log('Modal componentDidUpdate', this.props.show, prevProps.show)
    if (this.props.show != prevProps.show) {
      this.setState({
        stateShow: true,
        opacity: this.props.show?1:0,
      })
    }
  }

  render() {

    let {
      show,
      header,
      footer,
    } = this.props;

    let {
      opacity,
    } = this.state;

    let style = {};
    let contentStyle = {};

    let display = 'none';
    let pointerEvents = 'none';
    if (show && this.state.stateShow) {
      display = 'block';
      pointerEvents = 'auto';
    }
    style.display = display;
    style.opacity = opacity;
    //style.pointerEvents = pointerEvents;

    if (this.props.width) {
      contentStyle.width = this.props.width;
    }

    let footerComponent = undefined;
    if (footer) {
      footerComponent = (
        <div className="modal-footer">
          <h3>{this.props.footer}</h3>
        </div>
      )
    }

    return (
      <div className={classnames('aw-modal', {invert: this.props.invert})} style={style} onClick={this.onClose}>
        <div className="aw-modal-content" style={contentStyle} onClick={this.onClickContent}>
          {this.props.children}
        </div>
      </div>
    );
  }
}
